import React from 'react';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material'; // Import CircularProgress for the spinner

const LoadingButton = ({ label, icon, isLoading, onClick, sx }) => {
  const theme = useTheme(); // Access the current theme

  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px 16px',
        backgroundColor: isLoading ? theme.palette.action.disabledBackground : theme.palette.primary.main,
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        cursor: isLoading ? 'not-allowed' : 'pointer',
        fontSize: '1rem',
        lineHeight: 1.75,
        height: '40px',
        minWidth: '88px',
        justifyContent: 'center',
        ...sx,
      }}
    >
      {isLoading ? (
        <CircularProgress size={24} style={{ marginRight: '12px', color: '#fff' }} /> // Material UI spinner
      ) : (
        <div style={{ marginRight: '12px' }}>{icon}</div>
      )}
      {label}
    </button>
  );
};

export default LoadingButton;
